export const Environment = {
  Production: "production",
  Development: "development",
  Preview: "preview",
  Unknown: "unknown",
} as const

export type EnvironmentName = (typeof Environment)[keyof typeof Environment]

// Mirrors `frontendHostnames` in charts/src/apps/instahome/config.ts. Anything else (localhost,
// preview branches on an unknown host) resolves to Unknown so telemetry stays off.
const ENVIRONMENT_BY_HOSTNAME: Record<string, EnvironmentName> = {
  "instahome.instacover.ai": Environment.Production,
  "instahome.dev.instacover.ai": Environment.Development,
  "instahome.preview.instacover.ai": Environment.Preview,
}

export function resolveEnvironment(): EnvironmentName {
  return ENVIRONMENT_BY_HOSTNAME[window.location.hostname.toLowerCase()] ?? Environment.Unknown
}
